export default __webpack_public_path__ + "static/media/IMG-2726.1136586f.jpg";